/**
 * «Marca de los documentos de los médicos que no tienen una propia»
 * (administración, 20/10/2026).
 *
 * Los consentimientos y los postoperatorios del titular salen con el formato
 * de su clínica (lo de esta pantalla). Los de los demás médicos, con la marca
 * de su ficha (Catálogo → «Médicos: marca de sus documentos») y, si no
 * tienen una, con la que se elija aquí. Sin elegir ninguna, como siempre.
 * Las opciones son las marcas propias de Configuración → Marcas. El campo se
 * guarda con «Guardar cambios», con su rastro, y solo lo cambia un
 * administrador (el servidor lo exige igual) (backend: services/
 * marca_documentos.py).
 */
import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { SectionCard } from '../Common';
import { Label } from '../ui/label';

export const CAMPO_AJUSTE_MARCA = 'marca_documentos_otros_medicos';

/** Las marcas propias (no las procedencias externas) para elegir. */
export function marcasPropias(marcas) {
  return (Array.isArray(marcas) ? marcas : []).filter((m) => m && m.clave && !m.externa);
}

export function nombreDeMarca(m) {
  if (!m) return '';
  if (m.nombre_largo && m.nombre_corto) return `${m.nombre_largo} (${m.nombre_corto})`;
  return m.nombre_largo || m.nombre || m.clave;
}

export default function MarcaDocumentosAjuste({ form, setF, soloLectura }) {
  const [marcas, setMarcas] = useState(null);
  useEffect(() => {
    let vivo = true;
    api.get('/api/marcas')
      .then((r) => { if (vivo) setMarcas(marcasPropias(r?.data?.marcas)); })
      .catch(() => { if (vivo) setMarcas([]); });
    return () => { vivo = false; };
  }, []);
  const valor = form?.[CAMPO_AJUSTE_MARCA] || '';
  const conocida = !valor || (marcas || []).some((m) => m.clave === valor);
  return (
    <SectionCard title="Documentos de los médicos">
      <div className="space-y-2" id={`ajuste-${CAMPO_AJUSTE_MARCA}`}>
        <Label htmlFor="ajuste-marca-documentos">Marca de los documentos de los médicos que no tienen una propia</Label>
        <select id="ajuste-marca-documentos" value={valor} disabled={soloLectura || marcas === null}
          onChange={(e) => setF(CAMPO_AJUSTE_MARCA, e.target.value)}
          className="w-full border border-border rounded-md h-9 px-2 text-sm bg-white"
          data-testid="settings-marca-documentos">
          <option value="">Ninguna: el formato de esta clínica</option>
          {(marcas || []).map((m) => <option key={m.clave} value={m.clave}>{nombreDeMarca(m)}</option>)}
          {!conocida && <option value={valor}>{valor} (ya no está activa: no se aplica)</option>}
        </select>
        <p className="text-xs text-muted-foreground">
          Los consentimientos y los postoperatorios del titular salen siempre con el formato de esta clínica, con su
          firma y su sello. Los de los demás médicos, con la marca de su ficha (Catálogo de cirugías → «Médicos: marca
          de sus documentos») y, si no tienen, con esta: su cabecera, su logo, sus datos y su pie, y nunca la firma ni
          el sello del titular. Un consentimiento firmado se queda con la marca con la que se firmó. Solo la
          cambia un administrador.
        </p>
      </div>
    </SectionCard>
  );
}
